import * as localStorage from './local-storage-service';

export const getUserPreference = (key, params = {}) => localStorage.get(`${key}_${JSON.stringify(params)}`);

export const setUserPreference = (key, value, params = {}) => localStorage.set(`${key}_${JSON.stringify(params)}`, value);
